<template>
  <div class="addShop">
    <el-popover ref="shop" class="app-breadcrumb" placement="bottom" width="300" trigger="click">
      <div class="shop">
        <div class="shoplist">
          <div v-for="(item, index) in shopData" :key="index" class="shopCent" @click="shopShow(item)">
            <div style="display: flex; align-items: center">
              <svg-icon icon-class="vip" class-name="card-panel-icon" />
              <p>{{ item.mall_name }}</p>
              <span v-if="shopId == item.id" class="current-shop">当前店铺</span>
            </div>
            <el-divider />
          </div>
        </div>
        <!-- <el-button>+添加新店铺</el-button> -->
        <!-- <el-divider /> -->
        <el-row style="margin-top: 8px">
          <el-col class="text-center">
            <a :href="authLink" target="_blank">+添加新店铺</a>
          </el-col>
        </el-row>
      </div>
      <!-- <el-table :data="gridData">
    <el-table-column width="150" property="date" label="日期"></el-table-column>
    <el-table-column width="100" property="name" label="姓名"></el-table-column>
    <el-table-column width="300" property="address" label="地址"></el-table-column>
  </el-table> -->
      <!-- <el-button slot="reference">click 激活</el-button> -->
      <!-- <div slot="reference" /> -->

      <div slot="reference" class="shopButton">
        <span class="shop-name">{{ shopName }}</span>
        <span class="shop-down">切换店铺<i style="" class="el-icon-arrow-down" /></span>
      </div>
    </el-popover>
    <!-- <el-breadcrumb class="app-breadcrumb" separator="/">
    <transition-group name="breadcrumb">
      <el-breadcrumb-item v-for="(item, index) in levelList" :key="item.path">
        <span
          v-if="item.redirect === 'noRedirect' || index == levelList.length - 1"
          class="no-redirect"
        >
          {{ generateTitle(item.meta.title) }}
        </span>
        <a v-else @click.prevent="handleLink(item)">{{
          generateTitle(item.meta.title)
        }}</a>
      </el-breadcrumb-item>
    </transition-group>
  </el-breadcrumb> -->
  </div>
</template>

<script>
import { generateTitle } from '@/utils/i18n'
import pathToRegexp from 'path-to-regexp'
import { setDefaultShop } from '@/api/address'
import { getAuthLink } from '@/api/user'

export default {
  props: {
    shopData: {
      type: Array,
      default: function () {
        return []
      }
    },
    defaultShop: {
      type: Object,
      default: function () {
        return []
      }
    }
  },
  data() {
    return {
      levelList: null,
      shopName: '请选择店铺',
      shopId: '',
      authLink: ''
    }
  },
  watch: {
    $route(route) {
      // if you go to the redirect page, do not update the breadcrumbs
      if (route.path.startsWith('/redirect/')) {
        return
      }
      this.getBreadcrumb()
    },
    defaultShop(value) {
      this.shopId = value.shopId
      this.shopName = value.shopName
    }
  },
  mounted() {
    this.shopId = this.defaultShop.shopId
    this.shopName = this.defaultShop.shopName
    console.log(this.defaultShop.shopId)
    console.log(this.defaultShop.shopName)
    getAuthLink('add_shop').then(res => {
      if (res.data.code === 0) {
        this.authLink = res.data.data.auth_uri
      }
    })
  },
  created() {
    this.getBreadcrumb()
  },
  methods: {
    // 获取多店铺
    // async shop() {
    //   const { data } = await shop()
    //   if (data.code === 0) {
    //     console.log(data)
    //     this.shopData = data.data.list
    //     for (var item of data.data.list) {
    //       if (item.def === 1) {
    //         this.shopName = item.mall_name
    //         this.shopId = item.id
    //       }
    //     }
    //     localStorage.setItem('shopData', JSON.stringify(data.data))
    //   } else {
    //     console.log(data)
    //     this.$message.error(data.msg)
    //   }
    // },
    // 切换店铺
    shopShow(item) {
      console.log(item)
      this.shopId = item.id
      this.shopName = item.mall_name
      this.$refs.shop.showPopper = false
      setDefaultShop({ mall_id: item.mall_id }).then(res => {
        if (res.data.code === 0) {
          this.$message.success('切换成功')
          this.$emit('switch')
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    generateTitle,
    getBreadcrumb() {
      // only show routes with meta.title
      let matched = this.$route.matched.filter(item => item.meta && item.meta.title)
      const first = matched[0]

      if (!this.isDashboard(first)) {
        // eslint-disable-next-line object-curly-spacing
        matched = [{ path: '/dashboard', meta: { title: 'dashboard' } }].concat(matched)
      }

      this.levelList = matched.filter(item => item.meta && item.meta.title && item.meta.breadcrumb !== false)
    },
    isDashboard(route) {
      const name = route && route.name
      if (!name) {
        return false
      }
      return name.trim().toLocaleLowerCase() === 'Dashboard'.toLocaleLowerCase()
    },
    pathCompile(path) {
      // To solve this problem https://github.com/PanJiaChen/vue-element-admin/issues/561
      const { params } = this.$route
      var toPath = pathToRegexp.compile(path)
      return toPath(params)
    },
    handleLink(item) {
      console.log(item)
      const { redirect, path } = item
      if (redirect) {
        this.$router.push(redirect)
        return
      }
      this.$router.push(this.pathCompile(path))
    }
  }
}
</script>

<style lang="scss" scoped>
.shop {
  .shoplist{
    height: 400px;
    overflow-y: auto;

  }
  .pan-btn {
    padding: 12px 16px;
  }
  .shopCent {
    cursor: pointer;
    .card-panel-icon {
      font-size: 28px;
      margin-right: 3px;
    }
    p {
      display: inline-block;
      margin-right: 3px;
    }
    .current-shop {
      background: #51a4c8;
      color: #fff;
      font-size: 12px;
      display: inline-block;
      padding: 0 5px;
      line-height: 15px;
      border-radius: 4px;
    }
  }
}
.addShop {
  display: flex;
  height: 50px;
  align-items: center;
  cursor: pointer;
  margin: 0 5px;
  .shopButton {
    padding-right: 15px;
    box-sizing: border-box;
    background: #CEE7FF;
    border-radius: 4px 4px 4px 4px;
    color:#000000;
    height: 32px;
    font-size: 14px;
    padding: 7px 12px 7px 16px  ;
    min-width:250px;
    display: flex;
    .shop-name{
        display: inline-block;
        flex:1;
        max-width: 150px;
        white-space: nowrap;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
        overflow: hidden;
      }
      .shop-down{
        display: inline-flex;
        align-items: center;
        font-size: 12px;
        i{
          margin:0 4px;
        }
      }
    .el-icon-arrow-down{
      font-size: 16px;
      // position: relative;
      // top:2px;
    }
    // .shopClind {

    //   display: flex;
    //   // height: 50px;
    //   align-items: center;

    //   .shopBorder {
    //     // border: 1px solid #e9e9e9;
    //     display: flex;
    //     border-radius: 4px;

    //     .shopCont {
    //       box-sizing: border-box;
    //       padding-right: 6px;
    //       border-radius: 4px;
    //       display: flex;
    //       align-items: center;

    //       .card-panel-icon {
    //         font-size: 28px;
    //       }
    //     }
    //     .shopContR {
    //       box-sizing: border-box;
    //       padding-right: 6px;
    //       border-radius: 4px;
    //       display: flex;
    //       align-items: center;
    //     }
    //   }
    // }
  }
}
// .app-breadcrumb.el-breadcrumb {
//   display: inline-block;
//   font-size: 14px;
//   line-height: 50px;
//   margin-left: 8px;

//   .no-redirect {
//     color: #97a8be;
//     cursor: text;
//   }
// }
.shopCent {
  .el-divider--horizontal {
    margin: 3px 0 !important;
  }
}
</style>
